import { useMutation } from "@tanstack/react-query";
import { getEssayTheme } from "../../queries/EssaySchedule";
import { useEssayScheduleStore } from "../../stores/essayScheduleStore";

export const useGetScheduleEssayThemeHook = () => {
    const { setEssaySchedule } = useEssayScheduleStore();

    const { mutate, isPending, isError } = useMutation({
        mutationKey: ['get-schedule-essay-theme'],
        mutationFn: ({ day, scheduleId, essayContentId }: { day: string, scheduleId: string, essayContentId?: string }) => getEssayTheme(day, scheduleId, essayContentId),
        onSuccess: (data) => {
            setEssaySchedule(data);
        },
        retry: false
    });

    return { mutate, isPending, isError };
};